import { MutationTree } from 'vuex'
import { UiState } from './types'

export const mutations: MutationTree<UiState> = {
    colorModeChanged(state, payload): void {
        state.colorMode = payload
    },

    menuStateChanged(state, payload): void {
        state.menuState = payload
    },
}
